<div class="row justify-content-center">
    <h1 class="justify-content-center center-block">Bonjour ...</h1>
</div>
<div *ngIf="!spinner" class="container-fluid mt-4">
    <div *ngFor="let equipment of equipements">
        <div  class="card" >
        <div class="row">
            <div class="col-6">
                    <div class="card-body">
                      <h5 class="card-title">Equipement type : {{equipment.type}}</h5>
                      <h5 class="card-title">Serial number : {{equipment.serial}}</h5>
                      <h5 class="card-title">Equipement : {{equipment.mark}}</h5>
                      <button id={{equipment.equipmentId.toString()}} type="button" class="btn btn-danger" (click)="report(equipment)">Nécessite intervention</button>
                    </div>
            </div>
            <div class="col-6">
                <img  width="300px" class="float-left" [src]="equipment.photos[0]?.url" alt="sans/">
            </div>

        </div>
        </div>
        
    </div>
    
</div>
<div *ngIf="spinner">
    <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status" >
          <span class="sr-only" id="loading"></span>
        </div>
    </div>
</div>

